import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class BranchTaxCreditableEditService {

  constructor(private http: HttpClient) { }

  saveBranchTaxCreditableForm(
    baseUrl: string,
    returnClobSettingsObj: any,
    defaultsChangeDetails: any[],
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    // Use correct endpoint and action code (matching AngularJS BranchTaxFactory.savePivotedData)
    // Handle baseUrl with or without trailing slash
    const baseUrlClean = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
    const url = `${baseUrlClean}/saveJsonAsPivotObject?action_code=brk8nt`;

    // Build payload exactly like AngularJS BranchTaxFactory.savePivotedData
    // clob_settings should only contain scenario and object_id (matching AngularJS pattern)
    const clobSettings = {
      scenario: returnClobSettingsObj.scenario,
      object_id: returnClobSettingsObj.object_id
    };

    let params = _.merge({}, globalService?.globalParams || {}, filterParams);
    params = _.extend({ clob_data: JSON.stringify(defaultsChangeDetails) }, params);
    params = _.extend({ clob_settings: JSON.stringify(clobSettings) }, params);
    
    // Build checkLockedbj from rowData (matching f-schdd.service.ts pattern)
    const checkLockedbj = [{
      "leid": rowData.LEID,
      "me_code": rowData.ME_CODE,
      "cdr_number": rowData.CDR_NO || rowData.MARS,
      "reporting_period": rowData.REPORTING_PERIOD,
      "combination_key": returnClobSettingsObj.object_id || rowData.COMBINATION_KEY,
      "scenario_key": parseInt(returnClobSettingsObj.scenario || filterParams.scenario || rowData.SCENARIO || "1")
    }];
    params.checkLockedbj = JSON.stringify(checkLockedbj);

    // Ensure required parameters are set (optimized - set only if missing, no double-checking)
    if (!params.tax_year) {
      params.tax_year = filterParams.tax_year || rowData.TAX_YEAR || returnClobSettingsObj?.tax_year || globalService?.globalParams?.tax_year || globalService?.tax_year || '';
    }
    if (!params.scenario) {
      params.scenario = filterParams.scenario || rowData.SCENARIO || returnClobSettingsObj?.scenario || globalService?.globalParams?.scenario || globalService?.scenario || '';
    }
    if (!params.jcd_key) {
      params.jcd_key = filterParams.jcd_key || rowData.JCD_KEY || returnClobSettingsObj?.jcd_key || globalService?.globalParams?.jcd_key || globalService?.jcd_key || 250;
    }
    if (params.scenarioCode === undefined || params.scenarioCode === null || params.scenarioCode === '') {
      params.scenarioCode = params.scenario_code || filterParams.scenarioCode || filterParams.scenario_code || rowData.scenarioCode || rowData.scenario_code || rowData.SCENARIO_TYPE_CODE || returnClobSettingsObj?.scenarioCode || returnClobSettingsObj?.scenario_code || globalService?.globalParams?.scenarioCode || globalService?.scenarioCode || 'RAF';
      if (params.scenario_code) delete params.scenario_code;
    }
    if (params.is_issue_key_enabled === undefined || params.is_issue_key_enabled === null || params.is_issue_key_enabled === '') {
      params.is_issue_key_enabled = filterParams.is_issue_key_enabled || rowData.is_issue_key_enabled || returnClobSettingsObj?.is_issue_key_enabled || globalService?.globalParams?.is_issue_key_enabled || globalService?.is_issue_key_enabled || 'N';
    }

    // Convert to URLSearchParams for form-urlencoded format (matching AngularJS transformRequest behavior)
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      const value = params[key];
      if (value !== undefined && value !== null) {
        urlEncoded.set(key, value.toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }

  getTagDetailsData(
    baseUrl: string,
    combinationKey: any,
    taxYear: any,
    scenario: any,
    issueKey: any,
    globalService: any
  ): Observable<any> {
    const params: any = {
      "action_code": 'm6myyu',
      "combination_key": combinationKey,
      "p_tax_year": taxYear,
      "p_scenario": scenario,
      "p_issue_key": issueKey || 0
    };

    // Handle baseUrl with or without trailing slash
    const baseUrlClean = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
    const url = `${baseUrlClean}/loadJsonObject`;

    // Convert to URLSearchParams for form-urlencoded format
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }

  getSummaryInfo(
    baseUrl: string,
    params: any,
    globalService: any
  ): Observable<any> {
    // Handle baseUrl with or without trailing slash
    const baseUrlClean = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
    const url = `${baseUrlClean}/loadJsonObject?action_code=42kxhl`;

    // Convert to URLSearchParams for form-urlencoded format
    const urlEncoded = new URLSearchParams();
    if (params) {
      Object.keys(params).forEach(key => {
        if (params[key] !== undefined && params[key] !== null) {
          urlEncoded.set(key, params[key].toString());
        }
      });
    }

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }
}

